import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentToBritecoreComponent } from './sent-to-britecore.component';
import { SentToBritecoreListComponent } from './sent-to-britecore-list/sent-to-britecore-list.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../../shared/shared.module';

import { BritecoreDetailsSuspendedPaymentModalComponent } from './britecore-suspended-modal/britecore-details-suspended-payment-modal/britecore-details-suspended-payment-modal.component';
import { SuspendedPaymentRelatedDocComponent } from '../shared/suspended-payment-related-doc/suspended-payment-related-doc.component';
import { IpxSuspendedPaymentRelatedDocComponent } from '../shared/ipx-suspended-payment-related-doc/ipx-suspended-payment-related-doc.component';
import { ModalModule } from 'ngx-bootstrap';
import { BritecoreSuspendedPaymentRelatedDocComponent } from '../shared/britecore-suspended-payment-related-doc/britecore-suspended-payment-related-doc.component';

const routes: Routes = [
  { path: '', component: SentToBritecoreComponent }
];

@NgModule({
  declarations: [
    SentToBritecoreComponent,
    SentToBritecoreListComponent,
    BritecoreDetailsSuspendedPaymentModalComponent,
    BritecoreSuspendedPaymentRelatedDocComponent
    
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    ModalModule
  ],
  entryComponents: [BritecoreDetailsSuspendedPaymentModalComponent]
})
export class SentToBritecoreModule { }
